import  dwellingBlocks  from "apis/dwellingBlocks/index";
import { WebApiRequest, HTTP_POST, HTTP_GET } from "../../tools/webservice";

type MountedRef = React.MutableRefObject<boolean>;
type SuccessCallback<T = any> = (response: T) => void;
type ErrorCallback = (error: any) => void;

export const getIsIntegrated = (
  customerNumber: number,
  successCallback: SuccessCallback<boolean>,
  mountedRef: MountedRef
) =>
  WebApiRequest({
    method: HTTP_GET,
    endpoint: dwellingBlocks.isIntegrated(customerNumber),
    successCallback,
    mountedRef,
  });

export const sendMessage = (
  controlIdNumber: number,
  requiresAttention: boolean,
  note: string,
  successCallback: SuccessCallback<void>,
  errorCallback: ErrorCallback,
  mountedRef: MountedRef
) =>
  WebApiRequest({
    method: HTTP_POST,
    payload: {
      controlIdNumber,
      requiresAttention,
      note,
    },
    endpoint: dwellingBlocks.message(controlIdNumber),
    successCallback,
    errorCallback,
    mountedRef,
  });